var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTickboxCheckFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.71,5.29l-2-2-.71-.29H6l-.71,.29-2,2-.29,.71v12l.29,.71,2,2,.71,.29h12l.71-.29,2-2,.29-.71V6l-.29-.71ZM12.48,15h-.89l-3.29-3.29,1.41-1.41,2.21,2.21,3.3-4.13,1.56,1.25-4.3,5.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickboxCheckFilled);
export default __webpack_public_path__ + "static/1770312069/media/icon-tickbox-check-filled.dfd5b7bae0a0a96663de27dca7875c65.svg";
export { ForwardRef as ReactComponent };